var map = {
	"./archive.svg": "8238",
	"./chart-bar.svg": "8077",
	"./clipboard.svg": "4247",
	"./config.svg": "0d82",
	"./download.svg": "f28e",
	"./employees.svg": "578a",
	"./equipo.svg": "a7a1",
	"./fire.svg": "62e5",
	"./hallazgos.svg": "5a28",
	"./home.svg": "ac9d",
	"./monitoring.svg": "5464",
	"./repuesto.svg": "0435",
	"./spci.svg": "26de",
	"./status.svg": "c10e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";